import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { ThemeProvider } from 'styled-components';
import { lightTheme } from '@themes/lightTheme';
import GlobalStyle from '@themes/GlobalStyle';
import DataDogErrorBoundary from '@utils/services/datadog/DataDogErrorBoundary';
import { LocaleProvider } from '@utils/locale/locale';
import { TestableProvider } from './utils/testable/testable';
import { SessionProvider } from '@utils/context/session-provider';
import { AppRouter } from './router';
import { ErrorBoundary } from '@components/ErrorBoundary';
import { initialiseDataDog } from '@utils/services/datadog/datadog-helpers';

// Initialize DataDog if enabled
if (import.meta.env.DD_APP_ID && import.meta.env.DD_CLIENT_TOKEN) {
  initialiseDataDog();
}

export const App: React.FC = () => {
  // At present USL has only light theme. If we ever add dark theme support,
  // we can make this dynamic based on user preference or system settings.
  const theme = lightTheme;

  // SessionProvider must be ancestor of LocaleProvider not descendant
  // to avoid reinitialising session context on locale change
  return (
    <HelmetProvider>
    <DataDogErrorBoundary fallback={<div>An error occurred</div>}>
      <ThemeProvider theme={theme}>
        <BrowserRouter>
          <TestableProvider>
            <SessionProvider>
              <LocaleProvider>
                <GlobalStyle />
                <ErrorBoundary>
                  <AppRouter />
                </ErrorBoundary>
              </LocaleProvider>
            </SessionProvider>
          </TestableProvider>
        </BrowserRouter>
      </ThemeProvider>
    </DataDogErrorBoundary>
    </HelmetProvider>
  );
};
